import Grid from '@mui/material/Grid';
import type React from 'react';
import { useState } from 'react';

import Dropdown from '@/components/BaseLibrary/Dropdown/Dropdown';
import GridContainer from '@/components/Layout/GridContainer/GridContainer';
import { SpacingContainer } from '@/components/SpacingContainer/SpacingContainer';
import useGlobalStyles from '@/styles/global.styles';
import type { ActionDropdownCF } from '@/types';

import useStyles from './ActionDropdown.styles';

interface ActionDropdownContentProps {
  content: ActionDropdownCF;
}

export default function ActionDropdown({
  content: {
    fields: { headline, subhead, label, placeholder, links },
  },
}: ActionDropdownContentProps): React.JSX.Element {
  const { classes: globalClasses } = useGlobalStyles({ fixed: true });
  const { classes, cx } = useStyles();
  const [selectedLink, setSelectedLink] = useState<string>('');

  const linkMap: Record<string, string> = links.reduce(
    (acc: Record<string, string>, link): Record<string, string> => {
      if (link?.fields?.url && link?.fields?.text) {
        acc[link.fields.text] = link.fields.url;
      }
      return acc;
    },
    {}
  );

  const sortedOptions = Object.keys(linkMap).sort((a, b) => a.localeCompare(b));

  const handleSelectChange = (selectedTitle: string) => {
    setSelectedLink(selectedTitle);
    const selectedOption = linkMap[selectedTitle];
    if (selectedOption) {
      // Legacy pages are external links so can't use router.push
      window.location.href = selectedOption;
    }
  };

  return (
    <SpacingContainer>
      <GridContainer
        gridProps={{
          className: classes.wrapper,
          rowSpacing: { xs: 2, sm: 3, lg: 4 },
        }}
        fixed
      >
        <Grid
          size={{
            xs: 12,
            md: 6,
          }}
        >
          {headline && <h2 className={classes.title}>{headline}</h2>}
          {subhead && (
            <p className={cx(globalClasses.bodyLg, classes.subtitle)}>
              {subhead}
            </p>
          )}
        </Grid>
        <Grid
          size={{
            xs: 12,
            md: 6,
          }}
        >
          <Dropdown
            onChange={handleSelectChange}
            options={sortedOptions}
            defaultOption={selectedLink}
            placeholder={placeholder}
            hideLabel={!label}
            label={label || ''}
          />
        </Grid>
      </GridContainer>
    </SpacingContainer>
  );
}
